/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureStorageAccount {
  /**
  * The name of the storage account
  */
  'name': string;
  /**
  * The location of the storage account
  */
  'location': string;
  /**
  * The resource group name where storage account is located
  */
  'resourceGroup': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceGroup",
      "baseName": "resourceGroup",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureStorageAccount.attributeTypeMap;
  }

  public constructor() {
  }
}

